export enum LandingPageVariants {
  LP_04 = '04',
  LP_10 = '10',
  LP_13 = '13',
  LP_14 = '14',
  LP_15 = '15',
  LP_16 = '16',
  LP_17 = '17',
  LP_18 = '18',
  LP_19 = '19',
  LP_20 = '20',
  LP_21 = '21',
  LP_22 = '22',
  LP_23 = '23',
  LP_24 = '24',
  LP_25 = '25',
  LP_26 = '26',
  LP_27 = '27',
  LP_28 = '28',
  LP_29 = '29',
  LP_30 = '30',
  LP_31 = '31',
  LP_32 = '32',
  LP_33 = '33',
  LP_34A = '34a',
  LP_34B = '34b',
  LP_34C = '34c',
  LP_34D = '34d',
  LP_34E = '34e',
  LP_34F = '34f',
  LP_34G = '34g',
  LP_34H = '34h',
  LP_34I = '34i',
  LP_34J = '34j',
  LP_REFERRAL = 'referral',
}

export const ALL_LANDING_PAGE_VARIANTS = Object.values(LandingPageVariants);
